// generated by srcset-codegen
import src from "./slack.png";

const width = 60;
const height = 60;
export default { src, width, height };
